/**
 * Cart Fetch Controller
 * Blocks warning script from polling cart.js
 */
(function() {
  'use strict';

  const CART_ENDPOINTS = ['/cart.js', '/cart.json'];
  const WARNING_SCRIPT_MARKERS = [
    'familybox.store/cdn/wpm/',
    'b1d2a099fw23dfb22ep557258f5m7a2edbaem.js'
  ];

  const originalFetch = window.fetch;
  let warningScriptCallCount = 0;
  const MAX_WPM_CALLS = 5; // Allow first 5 calls, then block

  function isCartRequest(url) {
    if (typeof url !== 'string') {
      url = url.toString();
    }
    return CART_ENDPOINTS.some(endpoint => url.includes(endpoint));
  }

  function isWarningScriptCall() {
    try {
      const stack = new Error().stack || '';
      const lines = stack.split('\n');
      if (lines.length > 2) {
        const isWPM = lines[2].includes('b1d2a099fw23dfb22ep557258f5m7a2edbaem.js');
        return isWPM;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  window.fetch = function(...args) {
    const [url] = args;

    // Check if this is a cart mutation (add/change/update)
    const isMutation = typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'));
    
    // Check if this is OCU (One Click Upsell) - always allow
    const isOCU = typeof url === 'string' && url.includes('?ocu');
    
    if (!isCartRequest(url)) {
      return originalFetch.apply(this, args);
    }

    // Always allow mutations and OCU calls
    if (isMutation || isOCU) {
      warningScriptCallCount = 0; // Reset WPM counter after mutation
      return originalFetch.apply(this, args);
    }

    if (isWarningScriptCall()) {
      warningScriptCallCount++;
      
      // Block WPM polling after MAX_WPM_CALLS
      if (warningScriptCallCount > MAX_WPM_CALLS) {
        console.log(`[WPM BLOCKED] Call #${warningScriptCallCount}, limit: ${MAX_WPM_CALLS}`, url);
        return Promise.resolve(new Response(JSON.stringify({ items: [], item_count: 0 }), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      console.log(`[WPM] Call #${warningScriptCallCount}`, url);
    }
    
    // Allow all cart.js calls without caching
    return originalFetch.apply(this, args);
  };
})();
